// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDco6G1wFJQiWr35-Akgn2hknkh96G2PBk",
  authDomain: "gokseongsafemap.firebaseapp.com",
  projectId: "gokseongsafemap",
  storageBucket: "gokseongsafemap.firebasestorage.app",
  messagingSenderId: "71664567447",
  appId: "1:71664567447:web:9d59cb3e9b0d46dc81d5d2",
  measurementId: "G-MXYNP5F65N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };

//BOAeFgEYpRbkmty6TvqJ046p-u4Qu1RRS1wmxWPv0ZAK3EXMpbDTXeNsbm59whFAvX0duqoBMmqNiEykCe6H3DA